import { SET_INITIAL_TEXT_CONTENTS, TextContentsActions } from '../actions/text-contents-action'
import { ITextContentState } from "../types";
import { defaultTextContents } from '../../service/TextContentsService'

export function textContentReducer(state: ITextContentState = defaultTextContents, action: TextContentsActions) {
  switch (action.type) {
    case SET_INITIAL_TEXT_CONTENTS: {
      return {
         ...state,
         footer: action.payload.footer,
      };
    }
    default:{
      return state;
    }
  }
}